import { environment } from '../env/environment'
import axios from 'axios'
import authHead from './auth-header'
import store from '../store'

export const baseUrl = `${environment.BaseUrl}/api/v1`
export const baseUrlv2 = `${environment.BaseUrl}/api/v2`
export const axiosInstance = axios.create({ baseUrl })


// handle Request and add globle token in header section
axiosInstance.interceptors.request.use(async (config) => {
    let token = authHead()
    const lang = store.getState()?.language?.lang
    if (token) {
        config.headers.Authorization = token.Authorization
        config.headers.language = lang
    }
    return config
}, (error) => {
    return Promise.reject(error)
}
)

// Add a 401 response interceptor
axiosInstance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error) {
        if (error.response && (error.response.status === 403 || error.response.status === 401)) {
            setTimeout(() => {
                localStorage?.clear()
                window.location = '/';
                localStorage.setItem("authError", JSON.stringify("Your login session has timed out. Please log in again to continue."))
            }, 1500)
            return Promise.reject(error.response.data.errors);
        }
        if (error.response && error.response.status === 404 && error.code !== "ERR_NETWORK") {
            error.message = "Server is offline. Please try again later."
        }
        return Promise.reject(error);
    }
});

// User LogIn
export const handleErrors = (error) => {
    if (!error) return;
    if (error && error.code === "ERR_NETWORK") {
        throw new Error("Network Error");
    } else if (error && error?.response) {
        if (error?.response?.status === 401) {
            throw new Error("Token Expire");
        }
        if (error?.response?.data?.message) {
            throw new Error(error?.response?.data?.message);
        }
    } else throw new Error("An unspecified error occurred.");
}
// user verify

export const GUEST_LOGIN = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/client/guestLogin`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const VALIDATE_GUEST_LOGIN_OTP = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/client/validateGuestLoginOtp`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const VERIFY_CART_DATA = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/client/category/verifyCartData`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const UPDATE_BASIC_DETAILS = async (params) => {
    try {
        const response = await axiosInstance.put(`${baseUrl}/client/update`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const UPDATE_CONTACT_DETAILS = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrlv2}/client/updateContactDetails`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const GET_BASIC_DETAILS = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/client/getDetail`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};